"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFailureSurvey = exports.setInitedSurvey = exports.loadSurveyFromConfig = void 0;
const loadSurveyFromConfig = (slug, revision, status) => {
    return {
        type: 'SURVEY_LOADED_FROM_CONFIG',
        params: {
            slug
        },
        data: revision,
        status
    };
};
exports.loadSurveyFromConfig = loadSurveyFromConfig;
const setInitedSurvey = (data, params, status) => {
    return {
        type: 'SURVEY_SET_INITED',
        data,
        params,
        status
    };
};
exports.setInitedSurvey = setInitedSurvey;
const setFailureSurvey = (data, params, status) => {
    return {
        type: 'SURVEY_SET_FAILURE',
        data,
        params,
        status
    };
};
exports.setFailureSurvey = setFailureSurvey;
